import { BasicComponent } from "haxt";

import "./Dashboard.scss";

export class Dashboard extends BasicComponent<{
	page: string;
	parts: string[];
}> {
	public render() {
		return (
			<div class="Dashboard">
				<h1>Admin Dashboard</h1>
				<p>Welcome to the admin dashboard. Here you can manage the content of the website.</p>
				<ul>
					<li><a href="/admin/events">Manage Events</a></li>
					<li><a href="/admin/study">Manage Study Resources</a></li>
					<li><a href="/admin/about">Manage About Pages</a></li>
					<li><a href="/admin/members">Manage Members</a></li>
				</ul>
			</div>
		);
	}
}